import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { mergeTailwindClasses } from '@kontentino/ui';
import Card from 'app/modules/analytics/components/shared/Card';

export interface ReportMetricCardSkeletonProps {
  className?: string;
  withComparisonPill?: boolean;
  withPlatformRow?: boolean;
  'data-cy'?: string;
}

const ReportMetricCardSkeleton: FC<ReportMetricCardSkeletonProps> = ({
  className,
  withComparisonPill = true,
  withPlatformRow = false,
  'data-cy': dataCy = 'report-metric-card-skeleton',
}) => {
  return (
    <Card
      className={mergeTailwindClasses('tw-w-full', className)}
      data-cy={dataCy}
    >
      <div className="tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-2">
        <Skeleton width="6.5rem" height={20} borderRadius={6} />
        <div className="tw-flex tw-w-full tw-flex-col tw-gap-2 lg:tw-flex-row lg:tw-items-center">
          <Skeleton
            inline
            width="4.5rem"
            height={34}
            borderRadius={6}
            className="tw-align-middle"
          />
          {withComparisonPill && (
            <Skeleton
              inline
              width="4.25rem"
              height={24}
              borderRadius={8}
              className="tw-align-middle"
            />
          )}
        </div>
      </div>
      {withPlatformRow && (
        <div className="tw-flex tw-w-full tw-items-center tw-gap-1 tw-rounded-md tw-bg-grayscale-10 tw-p-1">
          <Skeleton
            inline
            width={20}
            height={20}
            borderRadius={6}
            className="tw-align-middle"
          />
          <Skeleton
            inline
            width={20}
            height={20}
            borderRadius={6}
            className="tw-align-middle"
          />
        </div>
      )}
    </Card>
  );
};

export default ReportMetricCardSkeleton;
